<div>
  <form [formGroup]="formGroup" #ngForm="ngForm">
    <div class="row">
      <div class="col">
        <mat-form-field appearance="outline" (click)="onOrganizationalUnitClick()">
          <mat-label>{{ 'OrganizationalUnit' | translate }}</mat-label>
          <input id="organizational-unit-input" matInput formControlName="organizationalUnit"
            [matAutocomplete]="autocompleteOrganizationalUnit" maxlength="0" />
            <mat-icon matSuffix>{{ 'expand_more' }}</mat-icon>
            <mat-autocomplete #autocompleteOrganizationalUnit="matAutocomplete" [displayWith]="displayValue">
            </mat-autocomplete>
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Workplace' | translate }}</mat-label>
            <input id="workplace-input" matInput formControlName="temporaryWorkplace"
              placeholder="{{ 'Workplace' | translate }}" [matAutocomplete]="autocompleteTemporaryWorkplace" />
              <mat-autocomplete #autocompleteTemporaryWorkplace="matAutocomplete" [displayWith]="displayValue">
                @for (temporaryWorkplace of listOfTemporaryWorkplaces$ | async; track temporaryWorkplace) {
                  <mat-option
                    [value]="temporaryWorkplace">
                    {{ temporaryWorkplace.Name }}
                  </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'AgreementType' | translate }}</mat-label>
              <mat-select id="agreement-type-select" formControlName="agreementType">
                @for (agreementType of listOfAgreementTypes$ | async; track agreementType) {
                  <mat-option [value]="agreementType.Id">
                    {{ agreementType.Name }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col">
            @if (EmploymentType.EmploymentAgreement == employmentTypeId || EmploymentType.TemporaryEmploymentAgreement == employmentTypeId) {
              <mat-form-field appearance="outline"
                >
                <mat-label>{{ 'WPS-WorkingTimeGroup' | translate }}</mat-label>
                <mat-select formControlName="workingTimeGroup">
                  @for (workingTimeGroup of listOfWorkingTimeGroup$ | async; track workingTimeGroup) {
                    <mat-option #matOption
                      [value]="workingTimeGroup.Id">
                    {{ workingTimeGroup.Name | translate }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }
            @if (EmploymentType.MandateAgreement == employmentTypeId || EmploymentType.TemporaryMandateAgreement == employmentTypeId) {
              <mat-form-field appearance="outline"
                >
                <mat-label>{{ 'Legalization.Details.MonthlyHours' | translate }}</mat-label>
                <input id="days-count-input" matInput type="number" formControlName="hoursPerWeek" min="0">
              </mat-form-field>
            }
          </div>
        </div>
        <div class="row">
          <div class="col">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'EmploymentDateFrom' | translate }}</mat-label>
              <input id="employment-date-from-input" matInput [matDatepicker]="pickEmploymentDateFrom"
                formControlName="employmentDateFrom" [matDatepickerFilter]="employmentDateFromFilter"
                (dateChange)="checkEmploymentDays()" required />
                <mat-datepicker-toggle matSuffix [for]="pickEmploymentDateFrom"></mat-datepicker-toggle>
                <mat-datepicker #pickEmploymentDateFrom></mat-datepicker>
              </mat-form-field>
            </div>
            <div class="col">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'EmploymentDateTo' | translate }}</mat-label>
                <input id="employment-date-to-input" matInput [matDatepicker]="pickEmploymentDateTo"
                  formControlName="employmentDateTo" [matDatepickerFilter]="employmentDateToFilter"
                  (dateChange)="checkEmploymentDays()" />
                  <mat-datepicker-toggle matSuffix [for]="pickEmploymentDateTo"></mat-datepicker-toggle>
                  <mat-datepicker #pickEmploymentDateTo></mat-datepicker>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <mat-form-field appearance="outline">
                  <mat-label>
                    {{
                    ((employmentTypeId == EmploymentType.EmploymentAgreement || employmentTypeId ==
                    EmploymentType.TemporaryEmploymentAgreement)
                    ? 'JobTitle' : 'ActivityGroup')
                    | translate
                    }}
                  </mat-label>
                  <mat-select id="activity-group-select" formControlName="jobTitle">
                    @for (jobTitle of listOfJobTitles$ | async; track jobTitle) {
                      <mat-option #matOption [value]="jobTitle.Id">{{
                        jobTitle.Name | translate
                      }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field appearance="outline">
                  <mat-label>{{ 'JobTitleCode' | translate }}</mat-label>
                  <input id="job-title-code-input" matInput formControlName="jobTitleCode">
                </mat-form-field>
              </div>
            </div>
            <div>
              @if (hasAnyDescriptiveWageType$ | async) {
                @for (wage of dataSource.data; track wage; let i = $index) {
                  <div class="row" formArrayName="wages">
                    <div class="col-3 const-height-col" [formGroupName]="i">
                      <mat-form-field fxFill appearance="outline">
                        <mat-label>{{ 'WageType' | translate }}</mat-label>
                        <mat-select id="wage-type-select" formControlName="wageTypeId">
                          @for (wageType of listOfWageTypes$ | async | filterWageType : wages.value : i | filterWageTypeMaxCount : wages.value : i; track wageType) {
                            <mat-option
                              [value]="wageType.Id">
                              {{ wageType.Name }}
                            </mat-option>
                          }
                        </mat-select>
                        @if (wages.controls[i].get('wageTypeId').invalid && wages.controls[i].get('wageTypeId').touched) {
                          <mat-error
                            >
                            {{ 'InvalidField' | translate }}
                          </mat-error>
                        }
                      </mat-form-field>
                    </div>
                    @if (wages.controls[i].get('wageTypeId').value) {
                      @if (isDescriptiveType(wages.controls[i].get('wageTypeId').value)) {
                        <div class="col-4" [formGroupName]="i">
                          <mat-form-field fxFill appearance="outline" class="dynamic-height-form">
                            <mat-label>{{ getWageTypeName(wages.controls[i].get('wageTypeId').value) }}</mat-label>
                            <textarea id="wage-name-textarea" matInput formControlName="name" maxLength="2000" rows="1"></textarea>
                            @if (wages.controls[i].get('name').invalid && wages.controls[i].get('name').touched) {
                              <mat-error>
                                {{ 'InvalidField' | translate }}
                              </mat-error>
                            }
                          </mat-form-field>
                        </div>
                        <div class="col-4" [formGroupName]="i">
                          <mat-form-field fxFill appearance="outline" class="dynamic-height-form">
                            <mat-label>{{ 'CalculationDescription' | translate }}</mat-label>
                            <textarea id="wage-calculation-description-textarea" matInput formControlName="calculationDescription"
                            maxLength="2000" rows="1"></textarea>
                            @if (wages.controls[i].get('calculationDescription').invalid && wages.controls[i].get('calculationDescription').touched) {
                              <mat-error
                                >
                                {{ 'InvalidField' | translate }}
                              </mat-error>
                            }
                          </mat-form-field>
                        </div>
                      } @else {
                        <div class="col-3" [formGroupName]="i">
                          <mat-form-field fxFill appearance="outline">
                            <mat-label>{{ 'Wage' | translate }}</mat-label>
                            <input id="wage-value-input" matInput type="number" class="text-center" formControlName="value" min="0"
                              required />
                              @if (wages.controls[i].get('value').invalid && wages.controls[i].get('value').touched) {
                                <mat-error>
                                  {{ 'InvalidField' | translate }}
                                </mat-error>
                              }
                            </mat-form-field>
                          </div>
                          <div class="col-2" [formGroupName]="i">
                            <mat-form-field fxFill appearance="outline">
                              <mat-label>{{ 'Currency' | translate }}</mat-label>
                              <mat-select id="wage-currency-select" formControlName="currencyId">
                                @for (currency of listOfCurrencies$ | async; track currency) {
                                  <mat-option [value]="currency.Id">
                                    {{ currency.Name }}
                                  </mat-option>
                                }
                              </mat-select>
                              @if (wages.controls[i].get('currencyId').invalid && wages.controls[i].get('currencyId').touched) {
                                <mat-error
                                  >
                                  {{ 'InvalidField' | translate }}
                                </mat-error>
                              }
                            </mat-form-field>
                          </div>
                          <div class="col-3" [formGroupName]="i">
                            <mat-form-field fxFill appearance="outline">
                              <mat-label>{{ 'Description' | translate }}</mat-label>
                              <mat-select id="wage-description-select" formControlName="wageDescriptionId">
                                <mat-option [value]="null"></mat-option>
                                @for (wageDescription of filterWageDescriptions(listOfWageDescriptions$ | async, i); track wageDescription) {
                                  <mat-option
                                    [value]="wageDescription.Id">
                                    {{ wageDescription.Name }}
                                  </mat-option>
                                }
                              </mat-select>
                              @if (wages.controls[i].get('wageDescriptionId').invalid && wages.controls[i].get('wageDescriptionId').touched) {
                                <mat-error
                                  >
                                  {{ 'InvalidField' | translate }}
                                </mat-error>
                              }
                            </mat-form-field>
                          </div>
                        }
                      }
                      <div class="col-1 wage-action-column">
                        <button id="delete-wage-button" mat-icon-button color="primary" class="trash-button" (click)="deleteWage(i)"
                          [disabled]="!canDeleteWage()">
                          <mat-icon>delete</mat-icon>
                        </button>
                      </div>
                    </div>
                  }
                } @else {
                  @for (wage of dataSource.data; track wage; let i = $index) {
                    <div class="row" formArrayName="wages">
                      <div class="col-3" [formGroupName]="i">
                        <mat-form-field fxFill appearance="outline">
                          <mat-label>{{ 'Wage' | translate }}</mat-label>
                          <input id="wage-value-input" matInput type="number" class="text-center" formControlName="value" min="0"
                            required />
                            @if (wages.controls[i].get('value').invalid && wages.controls[i].get('value').touched) {
                              <mat-error>
                                {{ 'InvalidField' | translate }}
                              </mat-error>
                            }
                          </mat-form-field>
                        </div>
                        <div class="col-2" [formGroupName]="i">
                          <mat-form-field fxFill appearance="outline">
                            <mat-label>{{ 'Currency' | translate }}</mat-label>
                            <mat-select id="wage-currency-select" formControlName="currencyId">
                              @for (currency of listOfCurrencies$ | async; track currency) {
                                <mat-option [value]="currency.Id">
                                  {{ currency.Name }}
                                </mat-option>
                              }
                            </mat-select>
                            @if (wages.controls[i].get('currencyId').invalid && wages.controls[i].get('currencyId').touched) {
                              <mat-error
                                >
                                {{ 'InvalidField' | translate }}
                              </mat-error>
                            }
                          </mat-form-field>
                        </div>
                        <div class="col-3" [formGroupName]="i">
                          <mat-form-field fxFill appearance="outline">
                            <mat-label>{{ 'WageType' | translate }}</mat-label>
                            <mat-select id="wage-type-select" formControlName="wageTypeId">
                              @for (wageType of listOfWageTypes$ | async | filterWageType : wages.value : i | filterWageTypeMaxCount : wages.value : i; track wageType) {
                                <mat-option
                                  [value]="wageType.Id">
                                  {{ wageType.Name }}
                                </mat-option>
                              }
                            </mat-select>
                            @if (wages.controls[i].get('wageTypeId').invalid && wages.controls[i].get('wageTypeId').touched) {
                              <mat-error
                                >
                                {{ 'InvalidField' | translate }}
                              </mat-error>
                            }
                          </mat-form-field>
                        </div>
                        <div class="col-3" [formGroupName]="i">
                          <mat-form-field fxFill appearance="outline">
                            <mat-label>{{ 'Description' | translate }}</mat-label>
                            <mat-select id="wage-description-select" formControlName="wageDescriptionId">
                              <mat-option [value]="null"></mat-option>
                              @for (wageDescription of filterWageDescriptions(listOfWageDescriptions$ | async, i); track wageDescription) {
                                <mat-option
                                  [value]="wageDescription.Id">
                                  {{ wageDescription.Name }}
                                </mat-option>
                              }
                            </mat-select>
                            @if (wages.controls[i].get('wageDescriptionId').invalid && wages.controls[i].get('wageDescriptionId').touched) {
                              <mat-error
                                >
                                {{ 'InvalidField' | translate }}
                              </mat-error>
                            }
                          </mat-form-field>
                        </div>
                        <div class="col-1 wage-action-column">
                          <button id="delete-wage-button" mat-icon-button color="primary" class="trash-button" (click)="deleteWage(i)"
                            [disabled]="!canDeleteWage()">
                            <mat-icon>delete</mat-icon>
                          </button>
                        </div>
                      </div>
                    }
                  }

                  @if (canAddWage$ | async) {
                    <button id="add-wage-button" mat-raised-button color="primary" type="button" (click)="addNewWage()"
                      >
                      <mat-icon>add_box</mat-icon>
                      <span>{{ 'AF-AddWage' | translate }}</span>
                    </button>
                  }
                </div>



                <div fxLayout="row" fxLayoutAlign="space-between center">
                  <button mat-raised-button color="accent" matStepperPrevious style="margin-top: 15px;">
                    <mat-icon>arrow_back</mat-icon>
                    {{ 'Back' | translate }}
                  </button>
                  <button mat-raised-button color="primary" [disabled]="!isFormReadyToSubmit" matStepperNext>{{ 'Next' | translate }}</button>
                </div>
              </form>
            </div>